module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "stage-column",
    class: _vm.stageConnectorClass
  }, [_c('div', {
    staticClass: "stage-name"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "builds-container"
  }, [_c('ul', _vm._l((_vm.jobs), function(job, index) {
    return _c('li', {
      key: job.id,
      staticClass: "build",
      class: _vm.buildConnnectorClass(index),
      attrs: {
        "id": _vm.jobId(job)
      }
    }, [_c('div', {
      staticClass: "curve"
    }), _vm._v(" "), (job.size === 1) ? _c('job-component', {
      attrs: {
        "job": job,
        "css-class-job-name": "build-content"
      }
    }) : _vm._e(), _vm._v(" "), (job.size > 1) ? _c('dropdown-job-component', {
      attrs: {
        "job": job
      }
    }) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/git/gitlab/~/vue-loader/lib/template-compiler?{"id":"data-v-e26d0a2c"}!/home/git/gitlab/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/graph/stage_column_component.vue
// module id = vxKc
// module chunks = 6